import { c as r } from "./create-non-enumerable-property.js";
import { e as a } from "./error-stack-clear.js";
import { e } from "./error-stack-installable.js";
var t = Error.captureStackTrace,
  o = function o(_o, s, c, l) {
    e && (t ? t(_o, s) : r(_o, "stack", a(c, l)));
  };
export { o as e };